import axiosInstance from "./api";

export const registerUser = async (data) => {
  try {
    const response = await axiosInstance.post("/auth/register", data, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data; // Return the response data
  } catch (error) {
    // Handle the error and throw an appropriate message
    throw new Error(
      error.response?.data?.message || "An error occurred during registration.",
    );
  }
};

export const loginUser = async (formData) => {
  try {
    const response = await axiosInstance.post("/auth/login", formData, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data; // Return token and user details
  } catch (error) {
    // Handle errors and throw appropriate messages
    throw new Error(
      error.response?.data?.message ||
      "An error occurred during login. Please try after sometime",
    );
  }
};

// Request password reset
export const forgotPassword = async (email) => {
  try {
    const response = await axiosInstance.post("/auth/forgot-password", {
      email,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Reset password
export const resetPassword = async (token, newPassword) => {
  try {
    const response = await axiosInstance.put(`/auth/reset-password/${token}`, {
      newPassword,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Resend verification email
export const resendVerificationEmail = async (email) => {
  try {
    const response = await axiosInstance.post("/auth/resend-verification", {
      email,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
      "Failed to resend verification email. Please try again.",
    );
  }
};

// ── OTP Verification ────────────────────────────────────────────────────────

/**
 * Send a 6-digit OTP to the given email.
 * Called before registration to verify the user owns the email.
 * Also checks if the phone number is already registered (if provided).
 */
export const sendOtp = async (email, phone) => {
  try {
    const response = await axiosInstance.post("/auth/send-otp", { email, phone });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to send OTP. Please try again.",
    );
  }
};

/**
 * Verify the OTP entered by the user.
 * Returns { success: true, verified: true } on success.
 */
export const verifyOtp = async (email, otp) => {
  try {
    const response = await axiosInstance.post("/auth/verify-otp", { email, otp });
    return response.data;
  } catch (error) {
    throw new Error(
    );
  }
};

// ── ONBOARDING DRAFT ENDPOINTS ──────────────────────────────────────────────

export const getRegistrationDraft = async () => {
  try {
    const response = await axiosInstance.get("/auth/draft");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch draft.");
  }
};

export const saveRegistrationDraft = async (step, draftData) => {
  try {
    const response = await axiosInstance.put("/auth/draft", { step, draftData });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to save draft.");
  }
};

export const finalizeRegistration = async (draftData) => {
  try {
    const response = await axiosInstance.post("/auth/finalize-registration", { draftData });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to finalize registration.");
  }
};
